<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <router-link to="/profile/setting" class="btn btn-light btn-sm rounded"
          ><i class="fas fa-arrow-left text-white mt-1"></i>
          <span class="btn btn-sm text-white">
            {{ $t("verification.back") }}</span
          >
        </router-link>
      </div>
    </div>
    <div v-if="!loading_user">
      <div class="row justify-content-center mt-2" v-if="two_step_verification">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <span
                    >{{ $t("verification.2-step-verification-is-on-since") }}
                    {{ user_profile.last_update_2fa }}</span
                  >
                </div>
                <div class="col-6 text-right">
                  <b-button
                    class="btn"
                    variant="primary"
                    @click="modalVerifPassword('turn_off')"
                  >
                    {{ $t("verification.turn-off") }}</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <b>{{ $t("verification.available-second-steps") }} </b>
          <p>{{ $t("verification.a-second-step") }}</p>
        </div>

        <!-- <div class="col-12" >
            <div class="card border-primary border-left">
              <div class="card-body">
               <div class="row">
                <div class="col-1 text-center">
                    <i class="fa fa-envelope fa-2x"></i>
                </div>
                <div class="col-8">
                   <b>{{ $t("verification.voice-or-text") }} <span v-if="user_profile.tfa.type == 'default'">(Default)</span></b> <br>
                    <span v-if="user_profile.tfa"> {{ user_profile.tfa.tfa_email }} </span> <span class="text-success">Verified</span> <br>
                    {{ $t("verification.verification-codes") }}
                </div>
                
                <div class="col-3 text-right">
                    <h5 class="text-truncate font-size-14 mt-2">
                      <router-link to="/profile/setting/two-step-verification" class="btn-block" > <i class="fa fa-chevron-right text-white mr-2"> </i> </router-link>
                    </h5>
                </div>
               </div>
              </div>
            </div>
          </div> -->

        <div class="col-12">
          <div
            class="card border mb-0"
            v-if="user_profile.tfa.type == 'auth_app'"
          >
            <a
              href="#"
              class="text-muted"
              @click="modalVerifPassword('auth_app')"
            >
              <div
                class="card-body"
                :class="
                  user_profile.tfa.type == 'auth_app'
                    ? 'border-left border-primary'
                    : ''
                "
              >
                <div class="row">
                  <div class="col-1 text-center">
                    <i class="bx bx-lock bx-md"></i>
                  </div>
                  <div class="col-8">
                    <b
                      >{{ $t("verification.authenticator-app") }}
                      <span v-if="user_profile.tfa.type == 'auth_app'"
                        >(Default)</span
                      >
                    </b>
                    <br />
                    <span> {{ $t("verification.use-the-authenticator") }} </span
                    ><br />
                  </div>
                  <div class="col-3 text-right">
                    <h5 class="text-truncate font-size-14 mt-2">
                      <router-link
                        to="/profile/setting/two-step-verification"
                        class="btn-block"
                      >
                        <i class="fa fa-chevron-right text-white mr-2"> </i>
                      </router-link>
                    </h5>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div class="card border">
            <div
              class="card-body"
              :class="
                user_profile.tfa.type == 'default'
                  ? 'border-left border-primary'
                  : ''
              "
            >
              <div class="row">
                <div class="col-1 text-center">
                  <i class="fa fa-envelope fa-2x"></i>
                </div>
                <div class="col-8">
                  <b
                    >{{ $t("verification.voice-or-text") }}
                    <span v-if="user_profile.tfa.type == 'default'"
                      >(Default)</span
                    ></b
                  >
                  <br />
                  <span v-if="user_profile.tfa">
                    {{ user_profile.tfa.tfa_email }}
                  </span>
                  <span class="text-success">Verified</span> <br />
                  {{ $t("verification.verification-codes") }}
                </div>

                <div class="col-3 text-right">
                  <h5 class="text-truncate font-size-14 mt-2">
                    <router-link
                      to="/profile/setting/two-step-verification"
                      class="btn-block"
                    >
                      <i class="fa fa-chevron-right text-white mr-2"> </i>
                    </router-link>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <b> {{ $t("verification.add-more-second") }} </b>
          <p>{{ $t("verification.set-up-additional-backup-steps") }}</p>
        </div>

        <div class="col-12">
          <div
            class="card border mb-0"
            v-if="user_profile.tfa.type !== 'auth_app'"
          >
            <a
              href="#"
              class="text-muted"
              @click="modalVerifPassword('auth_app')"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-1 text-center">
                    <i class="bx bx-lock bx-md"></i>
                  </div>
                  <div class="col-8">
                    <b>{{ $t("verification.authenticator-app") }} </b> <br />
                    <span> {{ $t("verification.use-the-authenticator") }} </span
                    ><br />
                  </div>
                  <div class="col-3 text-right">
                    <h5 class="text-truncate font-size-14 mt-2">
                      <router-link
                        to="/profile/setting/two-step-verification"
                        class="btn-block"
                      >
                        <i class="fa fa-chevron-right text-white mr-2"> </i>
                      </router-link>
                    </h5>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div class="card border mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-1 text-center">
                  <i class="fas fa-key fa-2x"></i>
                </div>
                <div class="col-8">
                  <b> {{ $t("verification.security-key") }} </b> <br />
                  <span> {{ $t("verification.a-security-key") }} . </span><br />
                </div>

                <div class="col-3 text-right">
                  <h5 class="text-truncate font-size-14 mt-2">
                    <router-link
                      to="/profile/setting/two-step-verification"
                      class="btn-block"
                    >
                      <i class="fa fa-chevron-right text-white mr-2"> </i>
                    </router-link>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center mt-lg-5" v-else>
        <div class="col-xl-5 col-sm-8" v-if="verification == 1">
          <div class="card">
            <div class="card-body">
              <div class="text-center">
                <div class="row justify-content-center mt-5 mb-2">
                  <div class="col-sm-6 col-8">
                    <div>
                      <img
                        src="@/assets/images/verification-img.png"
                        alt
                        class="img-fluid"
                        width="200"
                      />
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center mb-5">
                  <div class="col-lg-10">
                    <h4 class="mt-4 font-weight-semibold">
                      {{ $t("verification.two-step-verification") }}
                    </h4>
                    <p class="text-muted mt-3">
                      <b>{{ $t("verification.protect-your-account") }} </b>
                    </p>
                    <p>{{ $t("verification.prevent-hackers") }}.</p>
                    <div class="mt-4">
                      <!-- Button trigger modal -->
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="modalVerifPassword('turn_on')"
                        data-toggle="modal"
                        data-target="#verificationModal"
                      >
                        <b-spinner
                          v-if="loading"
                          label="Loading ..."
                          small
                        ></b-spinner>
                        <span v-if="!loading">
                          {{ $t("verification.get-started") }}
                        </span>
                        <span v-if="loading">
                          {{ $t("verification.get-started") }} ..
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-5 col-sm-8" v-if="verification == 2">
          <div class="card">
            <div class="card-body">
              <div class="text-center">
                <div class="row justify-content-center mt-5 mb-2">
                  <div class="col-sm-6 col-8">
                    <div>
                      <img
                        src="@/assets/images/verification-img.png"
                        alt
                        class="img-fluid"
                        width="200"
                      />
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center mb-5">
                  <div class="col-lg-10">
                    <h4 class="mt-4 font-weight-semibold">
                      {{ $t("verification.lets-set-up") }}
                    </h4>
                    <p class="text-muted mt-3">
                      <span>{{ $t("verification.what-email-do") }}</span>
                    </p>
                    <input
                      type="text"
                      class="form-control"
                      v-model="email_account"
                      placeholder="Email"
                    />
                    <div class="mt-4">
                      <p>
                        {{ $t("verification.ampm-will-only") }}
                      </p>

                      <!-- Button trigger modal -->
                      <button
                        type="button"
                        class="btn"
                        :class="email_account ? 'btn-primary' : 'btn-default'"
                        @click="setupEmails()"
                        data-toggle="modal"
                        data-target="#verificationModal"
                      >
                        <b-spinner
                          v-if="loading"
                          label="Loading ..."
                          small
                        ></b-spinner>
                        <span v-if="!loading">
                          {{ $t("verification.next") }}
                        </span>
                        <span v-if="loading">
                          {{ $t("verification.next") }} ..
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 text-left">
                    <button
                      type="button"
                      class="btn btn-default"
                      @click="updateVerification(1)"
                      data-target="#verificationModal"
                    >
                      {{ $t("verification.back") }}
                    </button>
                  </div>
                  <div class="col-6 text-right">
                    <p class="text-muted mt-2">
                      {{ $t("verification.step") }} 1 of 3
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-5 col-sm-8" v-if="verification == 3">
          <div class="card">
            <div class="card-body">
              <div class="text-center">
                <div class="row justify-content-center mt-5 mb-2">
                  <div class="col-sm-6 col-8">
                    <div>
                      <img
                        src="@/assets/images/verification-img.png"
                        alt
                        class="img-fluid"
                        width="200"
                      />
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center mb-5">
                  <div class="col-lg-10">
                    <h4 class="mt-4 font-weight-semibold">
                      {{ $t("verification.confirm-that") }}
                    </h4>
                    <p class="text-muted mt-3">
                      <span
                        >{{ $t("verification.ampm-just-sent") }}
                        {{ email_account }}.</span
                      >
                    </p>
                    <input
                      type="text"
                      class="form-control"
                      v-model="verification_code"
                      placeholder="Verification Code"
                    />
                    <div class="mt-4">
                      <p>
                        {{ $t("verification.didnt-get-it")
                        }}<a href="#" @click="setupEmails" class="text-success"
                          >{{ $t("verification.resend") }}.</a
                        >
                      </p>

                      <!-- Button trigger modal -->
                      <button
                        type="button"
                        class="btn"
                        :class="
                          verification_code ? 'btn-primary' : 'btn-default'
                        "
                        @click="setupCode()"
                        data-toggle="modal"
                        data-target="#verificationModal"
                      >
                        <b-spinner
                          v-if="loading"
                          label="Loading ..."
                          small
                        ></b-spinner>
                        <span v-if="!loading">
                          {{ $t("verification.next") }}
                        </span>
                        <span v-if="loading">
                          {{ $t("verification.next") }} ..
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 text-left">
                    <button
                      type="button"
                      class="btn btn-default"
                      @click="updateVerification(2)"
                      data-target="#verificationModal"
                    >
                      {{ $t("verification.back") }}
                    </button>
                  </div>
                  <div class="col-6 text-right">
                    <p class="text-muted mt-2">
                      {{ $t("verification.step") }} 2 of 3
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-5 col-sm-8" v-if="verification == 4">
          <div class="card">
            <div class="card-body">
              <div class="text-center">
                <div class="row justify-content-center mt-5 mb-2">
                  <div class="col-sm-6 col-8">
                    <div>
                      <img
                        src="@/assets/images/verification-img.png"
                        alt
                        class="img-fluid"
                        width="200"
                      />
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center mb-5">
                  <div class="col-lg-10">
                    <h4 class="mt-4 font-weight-semibold">
                      {{ $t("verification.it-worked") }}
                    </h4>
                    <p class="text-muted mt-3">
                      <span
                        >{{ $t("verification.now-that-you") }}
                        {{ email }} ?</span
                      >
                    </p>
                    <div class="mt-4">
                      <!-- Button trigger modal -->
                      <button
                        type="button"
                        class="btn"
                        :class="
                          verification_code ? 'btn-primary' : 'btn-default'
                        "
                        @click="turnOn()"
                        data-toggle="modal"
                        data-target="#verificationModal"
                      >
                        <b-spinner
                          v-if="loading"
                          label="Loading ..."
                          small
                        ></b-spinner>
                        <span v-if="!loading">
                          {{ $t("verification.turn-on") }}
                        </span>
                        <span v-if="loading">
                          {{ $t("verification.turn-on") }} ..
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="row">
                    <div class="col-6 text-left">
                      <button
                        type="button"
                        class="btn btn-default"
                        @click="updateVerification(3)"
                        data-target="#verificationModal"
                      >
                        {{ $t("verification.back") }}
                      </button>
                    </div>
                    <div class="col-6 text-right">
                      <p class="text-muted mt-2">
                        {{ $t("verification.step") }} 3 of 3
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row mt-lg-2">
        <div class="col-12 text-center">
          <div class="card">
            <div class="card-body p-5">
              <b-spinner
                v-if="loading_user"
                label="Loading ..."
                small
              ></b-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-turn-off"
      centered
      :title="
        this.$t('verification.turn-off') +
        ' ' +
        this.$t('verification.two-step-verification')
      "
      title-class="font-16"
      @ok="turnOff"
      hide-footer
    >
      <div class="row">
        <div class="col-12 mb-3">
          <span>
            {{ $t("verification.turn-off-2-step") }}
          </span>
        </div>
        <div class="col-md-12 mt-5">
          <div class="text-right">
            <b-button class="mt-3 mr-1" variant="light" @click="hideTurnOff"
              >CANCEL</b-button
            >
            <b-button class="mt-3 mr-1" @click="turnOff" variant="primary">
              <b-spinner v-if="loading" label="Loading ..." small></b-spinner>
              <span v-if="!loading"> {{ $t("verification.turn-off") }} </span>
              <span v-if="loading"> {{ $t("verification.turn-off") }} .. </span>
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-verif-password"
      centered
      :title="this.$t('verification.verification-password')"
      title-class="font-16"
      @ok="verifPassword()"
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <span>
            {{ $t("verification.to-continue") }}
          </span>
        </div>
        <div class="col-md-12 mt-3">
          <div class="">
            <label for="password">Password</label>
            <input
              type="password"
              name="password"
              id="password"
              v-model="password"
              class="form-control"
              placeholder="password"
              required
            />
          </div>
          <div v-if="submitted && $v.password.$error" class="invalid-feedback">
            <span v-if="!$v.password.required">{{
              $t("form.error.text")
            }}</span>
          </div>
          <div class="text-danger mt-2" v-if="error_password">
            * {{ error_password }}
          </div>
        </div>

        <div class="col-md-12 mt-2">
          <div class="text-right">
            <b-button
              class="mt-3 mr-1"
              variant="light"
              @click="hideVerifPassword"
              >Cancel</b-button
            >
            <b-button
              class="mt-3 mr-1"
              @click="verifPassword()"
              variant="primary"
            >
              <b-spinner
                v-if="loading_password"
                label="Loading ..."
                small
              ></b-spinner>
              <span v-if="!loading_password">
                {{ $t("verification.next") }}
              </span>
              <span v-if="loading_password">
                {{ $t("verification.next") }} ..
              </span>
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/user.service";
import appConfig from "@/app.config";
import moment from "moment";
import Stat from "@/components/widgets/stat";
import { required } from "vuelidate/lib/validators";
import { userService } from "@/helpers/authservice/user.service";
import verificationService from "@/helpers/verification.service";
import { revenueChart } from "./data-profile";

export default {
  page: {
    title: "Profile",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Stat },
  data() {
    return {
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      email: this.$store.state.authBackend.user.email,
      two_step_verification: false,
      type_modal_verif: "",
      verification: 1,
      verification_code: "",
      error_password: "",
      password: "",
      email_account: "",
      title: this.$t("verification.two-step-verification"),
      image_avatar: "",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Profile",
          href: "/profile",
        },
        {
          text: this.$t("malware.setting"),
          href: "/profile/setting",
        },
        {
          text: this.$t("verification.two-step-verification"),
          active: true,
        },
      ],
      loading_user: false,
      loading: false,
      loading_password: false,
      user_profile: {
        id_user: "",
        username: "",
        email: "",
        name: "",
        role: "",
        avatar: "",
        last_login: "",
        created_at: "",
        updated_at: "",
        is_active_2fa: "",
        last_update_2fa: "",
        tfa: "",
      },
      submitted: false,
    };
  },
  validations: {
    password: { required },
    user_profile: {
      name: { required },
      email: { required },
      username: { required },
    },
  },

  mounted() {
    this.getUser();
  },
  methods: {
    getUser() {
      let ferr = 0;
      this.loading_user = true;
      UserService.profileUser()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getUser();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            let val = response.data.data;
            this.user_profile.id_user = val.id_user;
            this.user_profile.username = val.username;
            this.user_profile.email = val.email;
            this.user_profile.name = val.name;
            this.user_profile.role = val.role ?? "-";
            this.user_profile.avatar = val.avatar ?? "";
            this.user_profile.last_login = val.last_login ?? "-";
            this.user_profile.is_active_2fa = val.is_active_2fa;
            this.user_profile.last_update_2fa = this.formatDate(
              val.last_update_2fa
            );
            this.user_profile.created_at = this.formatDate(val.created_at);
            this.user_profile.updated_at = this.formatDate(val.updated_at);
            this.user_profile.tfa = val.tfa;

            this.two_step_verification = val.is_active_2fa;
            this.loading_user = false;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getUser();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading_user = false;
            }
          }
        });
    },

    setup2f() {
      this.loading = true;
      let ferr = 0;
      const data = {
        email: "",
      };
      verificationService
        .start(data)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.setup2f();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            let key = response.data.data;
            // console.log('key', key);
            localStorage.setItem("tfa_key", key.tfa_key);
            this.loading = false;
            this.verification = 2;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.setup2f();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },

    setupEmails() {
      this.loading = true;
      let ferr = 0;
      const data = {
        email: this.email_account,
        token: localStorage.getItem("tfa_key"),
      };
      verificationService
        .setupEmail(data)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.setupEmails();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            let res = response;
            // console.log('res', res);
            this.loading = false;
            this.verification = 3;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.setupEmails();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },

    setupCode() {
      this.loading = true;
      let ferr = 0;
      const data = {
        otp: this.verification_code,
        token: localStorage.getItem("tfa_key"),
      };
      verificationService
        .setupCheck(data)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.setupCode();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            let res = response;
            // console.log('res', res);
            this.loading = false;
            this.verification = 4;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.setupCode();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },

    updateVerification(value) {
      this.verification = value;
    },

    turnOn() {
      this.loading = true;
      let ferr = 0;
      const data = {
        token: localStorage.getItem("tfa_key"),
      };
      verificationService
        .setupActivate(data)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.setupCode();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            let res = response;
            // console.log('res', res);

            // console.log('vc', this.verification_code);
            // console.log('email', this.email_account);
            this.two_step_verification = true;
            this.verification = 1;

            this.loading = false;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.setupCode();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },

    modalVerifPassword(type) {
      this.type_modal_verif = type;
      console.log("type", type);
      this.$bvModal.show("modal-verif-password");
    },

    modalTurnOff() {
      this.$bvModal.show("modal-turn-off");
    },

    hideTurnOff() {
      this.$bvModal.hide("modal-turn-off");
    },

    hideVerifPassword() {
      this.$bvModal.hide("modal-verif-password");
    },

    turnOff() {
      this.loading = true;
      let ferr = 0;
      const data = {
        token: localStorage.getItem("tfa_key"),
      };
      verificationService
        .setupDeactivate(data)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.turnOff();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            let res = response;
            this.loading = false;
            this.two_step_verification = true;
            this.verification = 1;
            this.verification_code = "";
            this.email_account = "";
            this.two_step_verification = false;
            localStorage.removeItem("tfa_key");
            this.hideTurnOff;
            this.$router.push("/profile/setting");
            ferr = 1;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.turnOff();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },

    verifPassword(e) {
      let ferr = 0;
      this.error_password = "";
      this.submitted = true;
      this.$v.password.$touch();
      if (this.password == "") {
        e.preventDefault();
      } else {
        this.loading_password = true;
        const data = {
          password: this.password,
        };
        verificationService
          .VerifPassword(data)
          .then((response) => {
            if (response.status == 201) {
              let new_token = response.data.refresh_access_token;
              userService.splitToken(new_token);
              this.verifPassword();
              this.$store.dispatch("notification/refreshtoken", "refresh");
              // ferr = 1;
            } else {
              ferr = 2;
              let res = response;
              // console.log('res', res);
              if (this.type_modal_verif == "turn_on") {
                this.setup2f();
              } else if (this.type_modal_verif == "turn_off") {
                this.modalTurnOff();
              } else if (this.type_modal_verif == "auth_app") {
                this.$router.push(
                  "/profile/setting/two-step-verification/auth-app"
                );
              }
              this.password = "";
              this.hideVerifPassword();
              this.loading_password = false;
            }
          })
          .catch((err) => {
            // console.log('err', err.response.data.errors.message);
            if (err.response) {
              this.error_password = err.response.data.errors.message;
            }

            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.verifPassword();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log(err);
                this.loading_password = false;
              }
            }
          });
      }
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
  },
};
</script>      